import loadable from '@loadable/component'

export const LatestNracTable = loadable(() => import('./LatestNracTable'))

export type { NracTableItem, NracTableProps } from './LatestNracTable'
